import { useEffect, useState } from 'react';
import type { OperatorTaskReminderPreviewResponse, OperatorTasksApiPreviewOperatorTaskRemindersRequest } from '@/core/generated/api';
import { operatorTaskService } from '@/entities/OperatorTask/api/operatorTaskService';
import { useDebouncedValue } from '@/shared/hooks/useDebouncedValue';
import { RequestStatus } from '@/shared/model/requestStatus';
import { getErrorMessage } from '@/shared/lib/errors';

/** Показывает ближайшие напоминания выбранного расписания */
export const useTaskReminderPreview = (
    query: OperatorTasksApiPreviewOperatorTaskRemindersRequest | null
) => {
    const serialized = query
        ? JSON.stringify(query)
        : '';

    const debounced = useDebouncedValue(serialized, 600);
    const [data, setData] = useState<OperatorTaskReminderPreviewResponse | null>(null);
    const [status, setStatus] = useState(RequestStatus.Idle);
    const [error, setError] = useState<string | null>(null);
    const [retry, setRetry] = useState(0);

    useEffect(() => {
        let current = true;
        setData(null);
        setError(null);

        if (!debounced || debounced !== serialized) {
            setStatus(RequestStatus.Idle);

            return;
        }

        setStatus(RequestStatus.Loading);
        const request: OperatorTasksApiPreviewOperatorTaskRemindersRequest = JSON.parse(debounced);

        void operatorTaskService.preview(request)
            .then((response) => {
                if (!current) return;

                setData(response);
                setStatus(RequestStatus.Success);
            })
            .catch((reason: unknown) => {
                if (!current) return;

                setStatus(RequestStatus.Error);
                setError(getErrorMessage(reason, 'Не удалось рассчитать напоминания'));
            });

        return () => { current = false; };
    }, [debounced, serialized, retry]);

    return {
        data,
        status,
        error,
        retry: () => setRetry((value) => value + 1)
    };
};
